import { render, staticRenderFns } from "./MapaBrasil.vue?vue&type=template&id=5bcd954c&scoped=true&"
import script from "./MapaBrasil.vue?vue&type=script&lang=js&"
export * from "./MapaBrasil.vue?vue&type=script&lang=js&"
import style0 from "./MapaBrasil.vue?vue&type=style&index=0&id=5bcd954c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcd954c",
  null
  
)

export default component.exports